import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';
import React from 'react';
import classes from './NoSurveys.module.scss';
import OinqMagglass from 'components/assets/oinq/SearchingOinq.svg';
import { useNoSurveysFragmentQuery } from './useNoSurveysFragmentQuery';
import { useNoSurveysFragmentQuery_noSurveysRef$key } from './__generated__/useNoSurveysFragmentQuery_noSurveysRef.graphql';

export type NoSurveysProps = {
  readonly noSurveysRef: useNoSurveysFragmentQuery_noSurveysRef$key;
};

export default function NoSurveys({ noSurveysRef }: Readonly<NoSurveysProps>) {
  useNoSurveysFragmentQuery(noSurveysRef);

  return (
    <div className={classes.fullWidth}>
      <OinqMagglass className={classes.noSurveysIcon} />
      <Heading level={3}>MMMM!</Heading>
      <Txt size="large" component="p" className={classes.noSurveysText}>
        We don&apos;t seem to have any surveys for you right now.
      </Txt>
      <Txt component="p" className={classes.noSurveysSecondaryText}>
        We are always looking out for the best surveys, so check back later, we&apos;re sure to find
        some soon.
      </Txt>

      {/* Removed until we've tested push notifications */}
      {/* <PushNotificationsCard pushNotificationsRef={data.notificationSubscriptions} /> */}
    </div>
  );
}
